var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"content-class":"","fill":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{ref:"item",attrs:{"data-key":"item","title":_vm.$t('item')}},[_c('SettingsItem')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }